"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({ tokenIdHashes: zod_1.z.array(zod_1.z.string().min(1).max(255)) });
exports.path = '/api-token-delete';
//# sourceMappingURL=index.js.map